// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2g3e3","overflowing":"ReadFullNote_overflowing__2hTkI"};